import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { CompileIcon } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { formatDate } from 'src/utils/misc';

interface EFControldReviewDueProps {
  showDate?: string;
  control: {
    id: string;
    name: string;
  };
  truncate?: boolean;
}

export const EFControldReviewDue: React.FC<EFControldReviewDueProps> = ({ showDate, control, truncate }) => {
  return (
    <Base
      iconComponent={<CompileIcon />}
      constentComponent={
        <Text nowrap={truncate}>
          {showDate && <Text className="sdate">{formatDate(showDate)}</Text>}Control{' '}
          <Link
            to={`/risk-management/control/${control.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Control'],
                  params: {
                    id: control.id,
                  },
                },
                tags: ['TIMELINE', 'RMP'],
              })
            }
          >
            <TextLink>{control.name}</TextLink>
          </Link>{' '}
          due for review.
        </Text>
      }
    />
  );
};
